import { createSlice } from '@reduxjs/toolkit';

import { POST_ROWS_PER_PAGE } from '@src/utils/constants';

const initialState = {
  search: null,
  tag: null,
  category: null,

  rowsPerPage: POST_ROWS_PER_PAGE,
  page: 1,
};

export const blogFiltersSlice = createSlice({
  name: 'blogFilters',
  initialState,
  reducers: {
    setBlogFilters: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
  selectors: {
    selectBlogFilters: (state) => state,
  },
});

export const { setBlogFilters } = blogFiltersSlice.actions;
export const { selectBlogFilters } = blogFiltersSlice.selectors;
export default blogFiltersSlice.reducer;
